(function () {
  'use strict';

  angular
      .module('tfc.Form')
      .directive('tfcAutofocus', tfcAutofocus);

  // @ngInject
  function tfcAutofocus($timeout) {
    return {
      restrict : 'A',
      link : function ($scope, $el, $attrs) {
        var autoFocus = $attrs.tfcAutofocus || 'true';
        $timeout(function () {
          if ($scope.$eval(autoFocus)) {
            $el[0].focus();
          }
        });
      }
    };
  }

})();
